import { epicRequest, reducersMerge, reduxFetchCreator, serverResponse } from 'app'

import type { SearchFilterSchema, TournamentSchema } from 'search'

const getInitialState = () =>
  serverResponse<TournamentSchema.Tournament[]>({
    key: '',
    data: [],
  })

const list = reduxFetchCreator<'searchTournaments', SearchFilterSchema, ReturnType<typeof getInitialState>>(
  'searchTournaments',
  getInitialState(),
  {
    fulfilled: (state, action) => {
      if (action.payload.originalAction?.payload.key === state.originalAction?.payload.key) {
        action.payload.data = [...state.data, ...action.payload.data]
      }

      return action.payload
    },
  },
)

const searchTournamentsEpic = epicRequest({
  actionType: list.actions.searchTournaments.type,
  debounce: 700,
  errorAction: list.actions.searchTournamentsError,
  fulfilledAction: list.actions.searchTournamentsFulfilled,
  request: ({ payload }) => ({
    body: { ...payload, type: 'tournaments' },
    method: 'post',
    url: 'search',
  }),
  untilTypes: list.actions.searchTournamentsCancel.type,
})

const toggleFollow = reduxFetchCreator<
  'searchTournamentsToggleFollow',
  { id: string; follow: boolean },
  ReturnType<typeof getInitialState>
>('searchTournamentsToggleFollow', getInitialState(), {
  fulfilled: (state, action) => {
    state.data = state.data.map((oldTournament) => {
      const newTournament = action.payload.data.find(({ id }) => id === oldTournament.id)
      return newTournament || oldTournament
    })
  },
})

const searchTournamentsToggleFollowEpic = epicRequest({
  actionType: toggleFollow.actions.searchTournamentsToggleFollow.type,
  debounce: 700,
  errorAction: toggleFollow.actions.searchTournamentsToggleFollowError,
  fulfilledAction: toggleFollow.actions.searchTournamentsToggleFollowFulfilled,
  request: ({ payload }) => ({
    body: { ...payload, type: 'tournaments' },
    method: 'post',
    url: 'search/follow',
  }),
  untilTypes: toggleFollow.actions.searchTournamentsToggleFollowCancel.type,
})

export const actions = {
  ...list.actions,
  ...toggleFollow.actions,
}

export const epics = [searchTournamentsEpic, searchTournamentsToggleFollowEpic]

export const reducer = reducersMerge(list.reducer, toggleFollow.reducer)
